import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeletePerson } from 'components/views/FounderTeam/_helpers/founderTeam.events';
import { $form, $view } from 'signals/global.signals';

const InvestorPersonDeleteModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'delete-person'}
    onHide={handleHideModal}
    enforceFocus={false}
    title="Delete Person"
    primaryButtonText="Delete"
    onPrimaryClick={handleSubmitDeletePerson}
    primaryButtonVariant="danger"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <div className="text-white">
      Are you sure you want to delete{' '}
      <strong>
        {$form.value.firstName} {$form.value.lastName}
      </strong>
      ? This action cannot be undone.
    </div>
  </SimpleModal>
);

export default InvestorPersonDeleteModal;
